<template>
  <el-row>
    <el-row
      :gutter="15"
      class="mb-3"
    >
      <el-col :span="10">
        <el-card
          header="Key Fields"
          shadow="never"
        >
          <PeekKeyFields :account="$props.account" />
        </el-card>
      </el-col>

      <el-col :span="14">
        <el-card
          header="Teams"
          shadow="never"
        >
          <PeekTeams :account="$props.account" />
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-card shadow="never">
          <div slot="header">
            <span>Notes</span>
            <el-button
              type="text"
              @click.native="() => $refs.notes.create()"
            >
              Add Note
            </el-button>
          </div>
          <Notes
            ref="notes"
            :resource="$props.account"
            truncate
            paginate
            pagination-layout="prev, pager, next"
            :limit="3"
          />
        </el-card>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import PeekKeyFields from '@/components/Application/CustomerService/Accounts/Account/Peek/KeyFields'
import PeekTeams from '@/components/Application/CustomerService/Accounts/Account/Peek/Teams'
import Notes from '@/components/Notes'

export default {
  components: {
    PeekKeyFields,
    PeekTeams,
    Notes
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  }
}
</script>
